import { z } from 'zod';

/**
 * Tenants (Sessao 37): a tela Configuracoes > Tenants e as rotas `/super/tenants` sao SO do SUPERADMIN (`tenants.gerenciar`).
 * Atravessam tenants por um papel de banco proprio (`triade_super`, so EXECUTE em funcoes SECURITY DEFINER estreitas): a RLS do app nao e relaxada.
 */
export const SLUG_TENANT = /^[a-z0-9](?:[a-z0-9-]{1,38})[a-z0-9]$/;

/** POST /super/tenants: cria o tenant e convida o primeiro ADMIN_TENANT (e-mail livre; link ou SMTP, como os demais convites). */
export const criarTenantSchema = z.object({
  nome: z.string().trim().min(1, 'Informe o nome da consultoria').max(200),
  slug: z.string().trim().toLowerCase().regex(SLUG_TENANT, 'Slug: 3 a 40 caracteres, letras minusculas, numeros e hifen (sem hifen nas pontas)'),
  adminEmail: z.string().trim().toLowerCase().email('E-mail invalido').max(200),
  adminNome: z.string().trim().min(1).max(200).optional(),
});
export type CriarTenantDto = z.infer<typeof criarTenantSchema>;

export interface TenantResponse {
  id: string;
  nome: string;
  slug: string;
  ativo: boolean;
  grupos: number;
  empresas: number;
  usuarios: number;
  criadoEm: string;
}

export interface TenantsResponse {
  tenants: TenantResponse[];
}

/** POST /super/tenants: o tenant criado e o convite do primeiro administrador (`link` so quando nao saiu por e-mail). */
export interface TenantCriadoResponse {
  tenant: TenantResponse;
  adminEmail: string;
  conviteExpiraEm: string;
  emailEnviado: boolean;
  envioFalhou: boolean;
  link: string | null;
}

// ---------- E-mail do servidor (Sessao 48): estado do SMTP e envio de teste, so SUPERADMIN ----------

/** GET /super/email: nunca usuario, senha nem a URL do SMTP. */
export interface EmailEstadoResponse {
  configurado: boolean;
  host: string | null;
  porta: number | null;
  /** `SMTP_FROM` como sai no e-mail (com o nome "XARP" quando o valor so traz o endereco). */
  remetente: string | null;
  /** Quantos testes ainda cabem na janela de 1 hora. */
  testesRestantes: number;
}

export const emailTesteSchema = z.object({ para: z.string().trim().toLowerCase().email('E-mail inválido').max(254) });
export type EmailTesteDto = z.infer<typeof emailTesteSchema>;

/** POST /super/email/teste: `enviado = false` traz o erro do SMTP traduzido (sem credenciais) em `mensagem`. */
export interface EmailTesteResponse {
  enviado: boolean;
  mensagem: string;
  /** Descricao tecnica sem segredos (codigo, resposta, servidor); so quando falhou. */
  detalhe: string | null;
  testesRestantes: number;
}

export const LIMITE_TESTES_EMAIL_POR_HORA = 5;
